module.exports = __webpack_public_path__ + "img/wave-1.7979042d.svg";